import { Link } from 'react-router-dom';
import { newsList, topicList } from '@/mocks/news';
import { mediaList } from '@/mocks/movies';

export default function RightRail() {
  const hot = [...mediaList].sort((a, b) => b.heat - a.heat).slice(0, 5);

  return (
    <aside className="w-full shrink-0 xl:w-72">
      <div className="space-y-5 xl:sticky xl:top-28">
        <div className="overflow-hidden rounded-lg border border-background-200 bg-background-50">
          <div className="flex items-center gap-2 border-b border-background-200 bg-background-100 px-4 py-3">
            <i className="ri-fire-line w-4 h-4 flex items-center justify-center text-base text-primary-600" />
            <h3 className="text-sm font-medium text-foreground-950">热度榜</h3>
            <span className="ml-auto text-[11px] text-foreground-400">实时</span>
          </div>
          <div className="divide-y divide-background-100">
            {hot.map((item, index) => (
              <Link key={item.id} to={`/detail/${item.id}`} className="flex items-center gap-2.5 px-4 py-2.5 transition hover:bg-background-100">
                <span className={`w-4 text-center font-heading text-sm font-bold ${index < 3 ? 'text-primary-500' : 'text-foreground-300'}`}>
                  {index + 1}
                </span>
                <div className="min-w-0 flex-1">
                  <p className="truncate text-[13px] text-foreground-900">{item.title}</p>
                  <p className="mt-0.5 text-[11px] text-foreground-400">{item.type} · {item.year}</p>
                </div>
                <span className="text-[11px] font-medium text-accent-700">{item.heat}</span>
              </Link>
            ))}
          </div>
        </div>

        <div className="rounded-lg border border-background-200 bg-background-50 p-4">
          <div className="flex items-center gap-2">
            <i className="ri-calendar-line w-4 h-4 flex items-center justify-center text-base text-secondary-600" />
            <h3 className="text-sm font-medium text-foreground-950">今日影视快讯</h3>
          </div>
          <div className="mt-3 space-y-2.5">
            {newsList.slice(0, 4).map((news) => (
              <Link key={news.id} to={`/detail/${news.relatedId}`} className="block border-l-2 border-background-200 pl-2.5 transition hover:border-primary-400">
                <p className="line-clamp-2 text-xs leading-relaxed text-foreground-700 hover:text-primary-700">{news.title}</p>
                <p className="mt-1 text-[10px] text-foreground-400">{news.date}</p>
              </Link>
            ))}
          </div>
        </div>

        <div className="rounded-lg border border-accent-200 bg-accent-50 p-4">
          <div className="flex items-center gap-2">
            <i className="ri-compass-3-line w-4 h-4 flex items-center justify-center text-base text-accent-700" />
            <h3 className="text-sm font-medium text-accent-900">专题推荐</h3>
          </div>
          <div className="mt-3 space-y-2">
            {topicList.slice(0, 3).map((topic) => (
              <Link key={topic.id} to={`/topic/${topic.id}`} className="block rounded-md bg-background-50/80 px-2.5 py-2 transition hover:bg-background-50">
                <p className="text-xs font-medium text-foreground-900">{topic.title}</p>
                <p className="mt-0.5 text-[10px] text-foreground-500">{topic.subtitle}</p>
              </Link>
            ))}
          </div>
        </div>

        <div className="rounded-lg border border-dashed border-background-300 bg-background-100/70 p-4">
          <div className="flex items-center gap-2 text-foreground-600">
            <i className="ri-information-line w-4 h-4 flex items-center justify-center text-base" />
            <h3 className="text-xs font-medium">温馨提示</h3>
          </div>
          <p className="mt-2 text-[11px] leading-relaxed text-foreground-500">
            本站仅提供影视资讯、作品资料与推荐，不提供在线播放与下载。所有作品信息均为演示数据。
          </p>
        </div>
      </div>
    </aside>
  );
}